export default "__VITE_ASSET__BPmk2uWt__"